import * as React from "react";
import { useContext } from "react";
import * as Immutable from "immutable";
import { useFormikContext } from "formik";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import { formHasErrors } from "util/FormsUtils";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { loadMatchingGroups } from "authentication/api/groupSync";
import prepareOktaLoadGroupsPayload from "authentication/logic/okta/prepareOktaLoadGroupsPayload";
import { OidcBackendMetaContext } from "authentication/components/oidc/config/components/OidcBackendMetaProvider";
import OktaMatchingGroupsContext from "./OktaMatchingGroupsContext";
const _loadGroups = (prepareSubmitPayload, setMatchingGroupsContext, currentFormValues, validateForm, backendId) => {
  const payload = prepareOktaLoadGroupsPayload(prepareSubmitPayload, currentFormValues, backendId, OKTA_TYPE_KEY);
  setMatchingGroupsContext({ finishedLoading: false, result: void 0 });
  return validateForm({ ...currentFormValues, teamSelection: Immutable.Set([""]) }).then((validationErrors) => {
    if (!formHasErrors(validationErrors)) {
      return loadMatchingGroups(payload).then((loadGroupsResult) => {
        if (loadGroupsResult) {
          setMatchingGroupsContext({ finishedLoading: true, result: loadGroupsResult });
        }
      }).catch((error) => {
        var _a, _b;
        const errors = Immutable.List([error == null ? void 0 : error.message, (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text]);
        setMatchingGroupsContext({ finishedLoading: true, result: { errors } });
      });
    }
    setMatchingGroupsContext({ finishedLoading: true, result: void 0 });
    return null;
  });
};
const _getButtonText = (loadedGroups, teamSelectionType) => {
  if (!loadedGroups || (loadedGroups == null ? void 0 : loadedGroups.size) === 0) return "Load matching groups";
  if (teamSelectionType !== "all") return "Reload matching groups";
  return "Reload matching groups";
};
const OktaLoadMatchingGroupsButton = ({ prepareSubmitPayload, disabled }) => {
  const { result, finishedLoading, setContextValue: setMatchingGroupsContext } = useContext(OktaMatchingGroupsContext);
  const { values: currentFormValues, validateForm } = useFormikContext();
  const { backendId } = useContext(OidcBackendMetaContext);
  const buttonText = _getButtonText(result == null ? void 0 : result.list, currentFormValues.teamSelectionType);
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "info",
      disabled,
      onClick: () => _loadGroups(prepareSubmitPayload, setMatchingGroupsContext, currentFormValues, validateForm, backendId),
      type: "button"
    },
    !finishedLoading ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: buttonText }) : buttonText
  );
};
export default OktaLoadMatchingGroupsButton;
